var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { Configuration, PublicApi } from "@api/index";
import { useConfig } from "./config";
var initialState = {};
export var ApiContext = React.createContext(initialState);
ApiContext.displayName = "ApiContext";
export var useApi = function () {
    var context = React.useContext(ApiContext);
    if (context === undefined) {
        throw new Error("useApi must be used within a ApiProvider");
    }
    return context;
};
export var ApiProvider = function (props) {
    var apiBasePath = useConfig().apiBasePath;
    var api = useMemo(function () {
        var config = new Configuration({
            basePath: apiBasePath,
        });
        var api = new PublicApi(config);
        return {
            api: api,
        };
    }, []);
    return _jsx(ApiContext.Provider, __assign({ value: api }, props), void 0);
};
